<nav class="navbar navbar-expand-md navbar-dark navcus">
    <img src="/assets/images/logo-04.png" alt="" class="cpd-logo">
    <a class="navbar-brand mb-0 topic">CMS <small> .version 1.3</small></a>
    <div class="collapse navbar-collapse" id="navbarNavAltMarkup" style="margin-right:90px;">
        <ul class="navbar-nav ml-auto">
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle no-arrow" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="name">{{auth_data.name}}</span>
                </a>
                <div class="dropdown-menu dropdown-menu-left" aria-labelledby="navbarDropdownMenuLink">
                    <a class="dropdown-item navitem" href="/">กลับหน้าหลัก</a>
                    <a class="dropdown-item navitem" role="button" (click)="logOut()">Log out</a>
                </div>
            </li>
        </ul>
    </div>
</nav>